import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { useMemo } from 'react';
import { useAppSelector } from '@/store/hooks';
import { getUseableFontFamily } from '@/micros/edit-project/grid-areas/main/components/theme-pack-font-variant-change/utils/get-useable-font-family';
import { selectFontPacks } from '@/store/slices/templates/selectors';

export const useGetFontPackOptions = () => {
  const fontPacks = useAppSelector(selectFontPacks);

  return useMemo(() => {
    const headingFonts: TReactSelectOption<string, string, { url: string; name: string }>[] = [];
    const bodyFonts: TReactSelectOption<string, string, { url: string; name: string }>[] = [];

    fontPacks?.forEach((pack) => {
      const headingName = pack.heading_name;
      const headingUrl = pack.heading_url;
      const bodyName = pack.body_name;
      const bodyUrl = pack.body_url;
      // meta is the url filename without the extension
      if (headingName && headingUrl) {
        if (!headingFonts.some((font) => font.value === headingUrl)) {
          headingFonts.push({
            label: getUseableFontFamily(headingName),
            value: headingUrl,
            meta: { url: headingUrl, name: headingName },
          });
        }
        if (!bodyFonts.some((font) => font.value === headingUrl)) {
          bodyFonts.push({
            label: getUseableFontFamily(headingName),
            value: headingUrl,
            meta: { url: headingUrl, name: headingName },
          });
        }
      }
      if (bodyName && bodyUrl) {
        if (!bodyFonts.some((font) => font.value === bodyUrl)) {
          bodyFonts.push({
            label: getUseableFontFamily(bodyName),
            value: bodyUrl,
            meta: { url: bodyUrl, name: bodyName },
          });
        }
        if (!headingFonts.some((font) => font.value === bodyUrl)) {
          headingFonts.push({
            label: getUseableFontFamily(bodyName),
            value: bodyUrl,
            meta: { url: bodyUrl, name: bodyName },
          });
        }
      }
    });

    const sortedHeadingFonts = headingFonts.sort((a, b) => a.label.localeCompare(b.label));
    const sortedBodyFonts = bodyFonts.sort((a, b) => a.label.localeCompare(b.label));

    return {
      headingFonts: sortedHeadingFonts,
      bodyFonts: sortedBodyFonts,
    };
  }, [fontPacks]);
};
